import type { MatchScore } from '@/types';

/** Счёт карточки: сеты — по победам в сетах, иначе сумма периодов. */
export const matchScoreView = (score?: MatchScore | null): { home: number; away: number; setsLine?: string } => {
  const sets = score?.sets;
  if (sets && sets.length > 0) {
    let home = 0;
    let away = 0;
    const parts: string[] = [];
    for (const set of sets) {
      const h = set.home || 0;
      const a = set.away || 0;
      if (h > a) home++;
      else if (a > h) away++;
      parts.push(`${h}:${a}`);
    }
    return { home, away, setsLine: parts.join(' · ') };
  }
  let home = 0;
  let away = 0;
  for (const period of score?.periods ?? []) {
    home += period.home || 0;
    away += period.away || 0;
  }
  return { home, away };
};
